import { Link, useParams } from "react-router-dom";
import { ServiceData } from "../../../lib/useServiceData"
import "../navbar.css"
import { useTranslation } from 'react-i18next';

export default function ServiceDropdownList() {
    const { i18n } = useTranslation();
    const { lang } = useParams();

    return (

        <ul id="servDropdown"
            className="flex-wrap position-absolute bg-light-gray border border-white rounded p-2 col-12 list-unstyled shadow">
            {ServiceData.map((data, index) => (
                <li key={index} className="col-12 col-md-4" >
                    <Link
                        to={`/${lang}/${data.btnLink}`}
                        className={`dropdown-item px-1 py-2 ${data.status}`}>
                        {i18n.language === "ar" ? data.title : data.titleEn}
                    </Link>
                </li>
            ))}
        </ul>
    );
}

